(function () {
  var protectedSelectors = [
    ".pp-ref-hero",
    ".pp-ref-category-card",
    ".pp-ref-product-card__image",
    ".pp-product__image-stage",
    ".pp-product__thumb",
    ".pp-experience-v2",
    ".pp-ref-experience",
    ".product-media-container",
    ".card-gallery",
    "img",
    "video"
  ].join(",");

  function isProtectedTarget(target) {
    return Boolean(target && target.closest && target.closest(protectedSelectors));
  }

  function prepareMedia() {
    document.querySelectorAll("img, video").forEach(function (media) {
      media.setAttribute("draggable", "false");
      media.addEventListener("dragstart", function (event) {
        event.preventDefault();
      });
    });
  }

  document.addEventListener("DOMContentLoaded", prepareMedia);

  document.addEventListener("contextmenu", function (event) {
    if (isProtectedTarget(event.target)) {
      event.preventDefault();
    }
  });

  document.addEventListener("dragstart", function (event) {
    if (isProtectedTarget(event.target)) {
      event.preventDefault();
    }
  });
})();
